export type CreditType = "cancellation" | "lateness";

/** Maps each credit type directly to its progress bar gradient colors. */
export const CREDIT_PROGRESS_BAR_CONFIG: Record<
  CreditType,
  { filledBarBackground: string; filledCircleBackground: string }
> = {
  cancellation: {
    filledBarBackground:
      "radial-gradient(166.7% 163.74% at -2.78% -4.17%, #6E7FAE 10%, #4B69A5 48.5%, #596DA3 100%)",
    filledCircleBackground: "linear-gradient(135deg, #4B69A5 0%, #596DA3 100%)",
  },
  lateness: {
    filledBarBackground:
      "radial-gradient(166.7% 163.74% at -2.78% -4.17%, #43902E 10%, #3F7D28 48.5%, #3B6A21 100%)",
    filledCircleBackground: "linear-gradient(135deg, #3F7D28 0%, #3B6A21 100%)",
  },
};

/** Height reserved above the progress bar for the tooltip bubble + pointer */
export const TOOLTIP_RESERVED_HEIGHT = "28px";

// The progress bar pill is curved only on the left side.
export const BAR_HEIGHT = 24;
export const BAR_BORDER_RADIUS = `${BAR_HEIGHT / 2}px 0 0 ${BAR_HEIGHT / 2}px`;

// The icon circle overlaps the end of the progress bar slightly, with a visual gap.
export const CIRCLE_SIZE = 52;
export const CIRCLE_BORDER_WIDTH = 3;
export const ICON_SIZE = 24;
// Horizontal distance the circle overlaps the pill, measured from the pill's
// right edge to where the circle's arc meets the pill's top/bottom edges.
// The pill ends here so that "100% fill" = "visually full."
export const CIRCLE_OVERLAP = Math.sqrt((CIRCLE_SIZE / 2) ** 2 - (BAR_HEIGHT / 2) ** 2);
